var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimatedCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 76,
    viewBox: "0 0 310 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 90,
    height: 55,
    rx: 4,
    fill: "url(#paint0)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    y: 5.45312,
    width: 90,
    height: 11.5842,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 6.23633,
    y: 27.7266,
    width: 78.4158,
    height: 5.34653,
    rx: 2.67327,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 6.23633,
    y: 39.3125,
    width: 23.1683,
    height: 6.23762,
    rx: 3.11881,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 33.8604,
    y: 39.3125,
    width: 23.1683,
    height: 6.23762,
    rx: 3.11881,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 65.9404,
    y: 36.6406,
    width: 11.5842,
    height: 11.5842,
    rx: 5.79208,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 73.0693,
    y: 36.6406,
    width: 11.5842,
    height: 11.5842,
    rx: 5.79208,
    fill: "white"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1s",
    values: "0 10; 0 -10; 0 10",
    repeatCount: "indefinite",
    begin: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 0.5,
    width: 90,
    height: 55,
    rx: 4,
    fill: "url(#paint1)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 110,
    y: 5.45312,
    width: 90,
    height: 11.5842,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 116.236,
    y: 27.7266,
    width: 78.4158,
    height: 5.34653,
    rx: 2.67327,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 116.236,
    y: 39.3125,
    width: 23.1683,
    height: 6.23762,
    rx: 3.11881,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 143.86,
    y: 39.3125,
    width: 23.1683,
    height: 6.23762,
    rx: 3.11881,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 175.94,
    y: 36.6406,
    width: 11.5842,
    height: 11.5842,
    rx: 5.79208,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 183.069,
    y: 36.6406,
    width: 11.5842,
    height: 11.5842,
    rx: 5.79208,
    fill: "white"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1s",
    values: "0 10; 0 -10; 0 10",
    repeatCount: "indefinite",
    begin: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 0.5,
    width: 90,
    height: 55,
    rx: 4,
    fill: "url(#paint2)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 220,
    y: 5.45312,
    width: 90,
    height: 11.5842,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 226.236,
    y: 27.7266,
    width: 78.4158,
    height: 5.34653,
    rx: 2.67327,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 226.236,
    y: 39.3125,
    width: 23.1683,
    height: 6.23762,
    rx: 3.11881,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 253.86,
    y: 39.3125,
    width: 23.1683,
    height: 6.23762,
    rx: 3.11881,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 285.94,
    y: 36.6406,
    width: 11.5842,
    height: 11.5842,
    rx: 5.79208,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 293.069,
    y: 36.6406,
    width: 11.5842,
    height: 11.5842,
    rx: 5.79208,
    fill: "white"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1s",
    values: "0 10; 0 -10; 0 10",
    repeatCount: "indefinite",
    begin: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0",
    x1: 90,
    y1: -0.373016,
    x2: -0.277294,
    y2: 57.1622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3F8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#057474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1",
    x1: 200,
    y1: -0.373016,
    x2: 109.723,
    y2: 57.1622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3F8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#057474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2",
    x1: 310,
    y1: -0.373016,
    x2: 219.723,
    y2: 57.1622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3F8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#057474"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedCards);
export default __webpack_public_path__ + "static/media/AnimatedCards.3e4d9fb8bba49f0aff570b79c6256835.svg";
export { ForwardRef as ReactComponent };